export default {"src":"/pro/_next/static/media/trx.46a130e8.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};